import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resetTableFilterState, setPaginationNavSource, clearPaginationNavSource } from "../store/actions";
import store from "../store";

/**
 * Set before navigating to a detail/child page so that returning to the list
 * page preserves the current pagination position.
 * @param {string} pageIdentifier - The PAGE_IDENTIFIERS value for this table
 */
export const setDetailNavSource = (pageIdentifier) => {
  store.dispatch(setPaginationNavSource(pageIdentifier));
};

/**
 * Clears the pagination source flag.
 */
export const clearDetailNavSource = () => {
  store.dispatch(clearPaginationNavSource());
};

/**
 * Call inside any page that owns a paginated table with useReduxPersistence.
 * On mount:
 *   - If the user is returning from one of this page's own detail pages → keep page number
 *   - Otherwise (different module or fresh visit) → reset page to 1
 * Either way, clears the flag so it doesn't bleed into later navigations.
 *
 * @param {string|string[]} pageIdentifiers - One or more PAGE_IDENTIFIERS values owned by this page
 * @returns {boolean} isFromOwnDetailPage - true when returning from a detail page of this list;
 */
export const usePaginationReset = (pageIdentifiers) => {
  const dispatch = useDispatch();
  const paginationNavSource = useSelector((state) => state.tableFilterReducer?.paginationNavSource);

  const ids = Array.isArray(pageIdentifiers) ? pageIdentifiers : [pageIdentifiers];
  const isFromOwnDetailPage = ids.includes(paginationNavSource);

  useEffect(() => {
    dispatch(clearPaginationNavSource());

    if (!isFromOwnDetailPage) {
      ids.forEach((id) => {
        dispatch(resetTableFilterState({ pageIdentifier: id, preserveCurrentPage: false }));
      });
    }
  }, []); 

  return isFromOwnDetailPage;
};
